import React from 'react';


class WeatherForecast extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    };
  render() { 
    console.log(this.props.weather,'this.props.weather');      
    return (
      <div>
    {this.props.url}
        {this.props.weather ?
          this.props.weather.map((item, idx) =>
            <div key={idx}>
              <img src={`http://openweathermap.org/img/w/${item.icon}.png`} alt="icon"/>              
              <p> <b>City: </b> {this.props.city}</p>
              <p> <b>Weather: </b> {item.main} , {item.description}</p>
              <p> <b>Temperature:</b> {parseFloat(this.props.temp.temp-273.15).toFixed(0)} C </p>
              <p> <b>Humidity: </b> {this.props.temp.humidity} %</p>
              <p> <b>Wind: </b>{this.props.wind.speed} mps </p>              
            </div>)
          : 
          <p></p>
        }
      </div >
    )
  }
}

export default WeatherForecast



